module.exports = __webpack_public_path__ + "static/media/gene_lists.451e3e0f.zip";